import React from 'react';
import Buttons from '../Common/Buttons';
import Ticks from '../Common/Ticks';
import { useLocale } from '../../localization/LocaleContext';
import { useCurrency } from '../../localization/CurrencyContext';
import '../NicheLanding/NicheLandingPage.css';

function InvoiceMockup({ t, formatCurrency }) {
    return (
        <div className="niche-invoice-mockup">
            <div className="niche-invoice-header">
                <div className="niche-invoice-logo-placeholder">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
                        <line x1="9" y1="9" x2="9.01" y2="9"/>
                        <line x1="15" y1="9" x2="15.01" y2="9"/>
                    </svg>
                </div>
                <div>
                    <div className="niche-invoice-title-text">INVOICE</div>
                    <div className="niche-invoice-number">#INV-2026-0087</div>
                </div>
            </div>
            <div className="niche-invoice-divider" />
            <div className="niche-invoice-parties">
                <div>
                    <div className="niche-invoice-label">{t('freelancers.invoiceFrom')}</div>
                    <div className="niche-invoice-name">{t('freelancers.invoiceSender')}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <div className="niche-invoice-label">{t('freelancers.invoiceTo')}</div>
                    <div className="niche-invoice-name">{t('freelancers.invoiceRecipient')}</div>
                </div>
            </div>
            <div className="niche-invoice-table">
                <div className="niche-invoice-table-header">
                    <span>{t('freelancers.invoiceItemHeader')}</span>
                    <span>{t('freelancers.invoiceAmountHeader')}</span>
                </div>
                <div className="niche-invoice-table-row">
                    <span>{t('freelancers.invoiceItem1')}</span>
                    <span>{formatCurrency(t('freelancers.invoiceItem1Price'))}</span>
                </div>
                <div className="niche-invoice-table-row">
                    <span>{t('freelancers.invoiceItem2')}</span>
                    <span>{formatCurrency(t('freelancers.invoiceItem2Price'))}</span>
                </div>
            </div>
            <div className="niche-invoice-total-row">
                <span className="niche-invoice-total-label">Total</span>
                <span className="niche-invoice-total-value">{formatCurrency(t('freelancers.invoiceTotal'))}</span>
            </div>
            <div className="niche-invoice-status">{t('freelancers.invoiceStatus')}</div>
        </div>
    );
}

function Banner(){
    const { t } = useLocale();
    const { formatCurrency } = useCurrency();

    return(
        <section className="niche-hero sp-60">
            <div className="container">
                <div className="row flex-column-reverse flex-lg-row align-items-center">
                    <div className="col-lg-6">
                        <h1 className="h-1 h-bold niche-hero-title">
                            {t('freelancers.bannerTitleStart')}{' '}
                            <span className="niche-hero-highlight">{t('freelancers.bannerTitleHighlight')}</span>
                        </h1>
                        <p className="niche-hero-description">
                            {t('freelancers.bannerSubtitle')}
                        </p>
                        <Buttons />
                        <div className="mt-20">
                            <Ticks />
                        </div>
                    </div>
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <InvoiceMockup t={t} formatCurrency={formatCurrency} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Banner;